import LavorisService from "../../services/LavorisService";
import { PrimaryButton } from "../../components/others/ButtonPrimary";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import { Input } from "../../components/core/Input";
import { INDEX } from "../../constants/routes";
import './TwoFAPage.scss';
import { Auth2FARequestService } from "../../services/auth/AuthenticationServices.type";
import { FranchiseLogo } from "../../components/others/FranchiseBranding";

const TwoFAPage = () => {
  const location = useLocation();
  const userId = location.state?.userId || "";
  const email = location.state?.email || "";
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      code: "",
      userId: userId,
    },
  });
  const navigate = useNavigate();
  const [loginError, setLoginError] = useState(false);
  const LavorisInstance = LavorisService.getInstance();
  const [loading, setLoading] = useState(false);

  const onSubmit = async (data: Auth2FARequestService) => {
    try {
      setLoginError(false);
      setLoading(true);
      const loginTokens = await LavorisInstance.Auth.verify2fa(data);
      await LavorisInstance.User.getProfile(loginTokens);
      navigate(INDEX);
    } catch (e) {
      setLoginError(true);
      const statusCode = typeof e === 'object' && e !== null && 'statusCode' in e ? (e as any).statusCode : undefined;
      if (statusCode === 401 || statusCode === 404) setLoginError(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid px-3 two-fa-container">
      <div className="row justify-content-center align-items-center vh-100">
        <div className="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5">
          <form
            onSubmit={handleSubmit(onSubmit)}
            className="two-fa-form bg-light rounded-3 shadow-lg my-4 p-4 p-md-5"
          >
            {/* Logo */}
            <div className="text-center mb-3">
              <FranchiseLogo className="two-fa-logo img-fluid" />
            </div>

            {/* Subtitle */}
            <div className="text-center mb-5">
              <h2 className="two-fa-subtitle text-danger fw-bold small mb-0">
                Portal Interno
              </h2>
            </div>

            {/* Instructions */}
            <div className="text-center mb-5">
              <p className="text-muted small mb-0">
                Ingresá el código que mandamos a tu correo
                <br />
                <strong>{email}</strong>
              </p>
            </div>

            {/* Code Input */}
            <div className="mb-5">
              <Input
                label="Tu código"
                fieldName="code"
                register={register}
                required
                type="text"
                error={errors.code}
              />
            </div>

            {/* Submit Button and Error */}
            <div className="d-grid">
              <PrimaryButton
                loading={loading}
                type="submit"
                text="Iniciar sesión"
                styles={`btn-danger fw-bold ${loading ? 'opacity-75' : ''}`}
              />

              {loginError && (
                <div className="text-center mt-3">
                  <span className="text-danger fw-bold small">
                    Código erróneo
                  </span>
                </div>
              )}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default TwoFAPage;